import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 保存主动发送的消息
export function webSaveClusterRecord(chatUser,content,type,otherParam,callback){
	let data = JSON.parse(JSON.stringify(chatUser))
	data.content = content
	data.type = type
	let is_send = 2
	if(otherParam.is_send !== undefined){
		is_send = otherParam.is_send
	}
	data.is_send = is_send
	request({
			method: 'post',
			url: 'ClusterChatRecord/saveMsg',
			data: data
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			CHAT_LAYER.msg(response.data.msg,{icon:2})
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据id，获取群聊天记录
export function webGetClusterRecord(id,callback){
	request({
			method: 'post',
			url: 'ClusterChatRecord/getById',
			data: {
			 id: id
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据id，删除聊天记录-软删除
export function webDeleteClusterRecord(id,callback){
	request({
			method: 'post',
			url: 'ClusterChatRecord/deleteById',
			data: {
			 id: id
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}